import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
  CommandShortcut,
} from '@/components/ui/command';
import useIsMac from '@/hooks/use-is-mac';
import { ArrowLongRightIcon } from '@heroicons/react/16/solid';
import { useRouter } from 'next/navigation';
import { useGetRoutes } from '../hooks/use-get-routes';

export function RoutesGroup({ onClose }: { onClose: () => void }) {
  const router = useRouter();
  const isMac = useIsMac();
  const navigationRoutes = useGetRoutes();
  return (
    <CommandGroup heading='Navigering'>
      <CommandItem
        onSelect={() => {
          router.back();
          onClose();
        }}
      >
        <ArrowLongRightIcon className='mr-2 size-4' />
        <span>Gå tillbaka...</span>
        <CommandShortcut>{isMac ? '⌘ + B' : 'ctrl + B'}</CommandShortcut>
      </CommandItem>
      <CommandItem
        onSelect={() => {
          router.push('/settings/organization/users');
          onClose();
        }}
      >
        <ArrowLongRightIcon className='mr-2 size-4' />
        <span>Gå till inställningar</span>
      </CommandItem>

      <CommandSeparator className='my-1' />
      {navigationRoutes.map((route) => (
        <CommandItem
          key={route.path + route.title}
          onSelect={() => {
            router.push(route.path);
            onClose();
          }}
        >
          <ArrowLongRightIcon className='mr-2 size-4' />
          <span>Gå till {route.title.toLowerCase()}</span>
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
